export function walkOrganizations(organizations, callback) {
    const result = [];
    walkOrganizationsRecursive(organizations, callback, 0, result);
    return result;
}
function walkOrganizationsRecursive(organizations, callback, level, result) {
    for (const organization of organizations) {
        result.push(callback(organization, level));
        walkOrganizationsRecursive(organization.children, callback, level + 1, result);
    }
}
